import '@archetype-themes/scripts/modules/animation-observer';
class SkinConcern extends HTMLElement {
    constructor() {
        super();

        this.mouseDown = false;
        this.startX; this.scrollLeft;

        this.container = this.querySelector('.skin-concern-container');
        this.list = this.querySelector('.skin-concern-list');

        this.list.addEventListener('mousemove', this.move.bind(this));
        this.list.addEventListener('mousedown', this.startDragging.bind(this));
        this.list.addEventListener('mouseup', this.stopDragging.bind(this));
        // this.list.addEventListener('mouseleave', this.stopDragging.bind(this));

        this.links = this.list.querySelectorAll('.concern-link');
        this.checkLinkActive();

        this.buttons = this.querySelectorAll('.skin-concern-scrollable');
        Array.from(this.buttons).forEach(function(button){
            button.addEventListener('click', this.scrollable.bind(this));
        }, this);

        this.showMore = this.querySelector('.skin-concern-showmore');
        this.showMore.addEventListener('click', this.toggleShowMore.bind(this));
    }
    checkLinkActive() {
        // scroll to first link active
        let has_link_active = false;
        Array.from(this.links).forEach(function(link){
            let parentE = link.parentElement;
            if(parentE.classList.contains('active') && parentE.offsetLeft > this.container.offsetLeft && !has_link_active) {
                this.list.scrollBy({left: link.offsetLeft - 35, behavior: 'smooth'});
                has_link_active = true;
            }
        }, this);
    }
    scrollable(e) {
        e.preventDefault();
        let scroll = 0;
        let move = e.target.closest('a').dataset.move;
        
        if(move == 'prev') {
            scroll = -200;
        }else {
            scroll = +200;
        }
        this.list.scrollBy({left: scroll, behavior: 'smooth'});
    }
    startDragging = (e) => {
        setTimeout(() => {
            this.linksHandler('disable');
            this.mouseDown = true;
            this.startX = e.pageX - this.list.offsetLeft;
            this.scrollLeft = this.list.scrollLeft;
        }, 300);
        
    }
      
    stopDragging = (e) => {
        this.mouseDown = false;
        setTimeout(() => {
            this.linksHandler('enable');
        }, 500);
    }
      
    move = (e) => {
        e.preventDefault();
        if(!this.mouseDown) { return; }
        const x = e.pageX - this.list.offsetLeft;
        const scroll = x - this.startX;
        this.list.scrollLeft = this.scrollLeft - scroll;
    }

    linksHandler(action) {
        Array.from(this.links).forEach(function(link){
            if(action == 'disable') {
                link.parentElement.classList.add('disable');
            }else {
                link.parentElement.classList.remove('disable');
            }
        }, this)
    }

    toggleShowMore(e) {
        e.preventDefault();
        if(this.list.classList.contains('show-all')) {
            this.list.classList.remove('show-all');
        }else {
            this.list.classList.add('show-all');
        }
    }
}
  
customElements.define('skin-concern', SkinConcern);